import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';
import { IconUserPlus } from '@tabler/icons-react';

const FirstClassVisitBadge = ({ ...props }: BadgeProps): JSX.Element => (
  <Badge
    variant='light'
    size='lg'
    radius='xl'
    color='blue'
    leftSection={<IconUserPlus size={12} style={{ display: 'block' }} />}
    sx={{ textTransform: 'none', fontWeight: 500 }}
    {...props}
  >
    First Class Visit
  </Badge>
);

export default FirstClassVisitBadge;
